import { useAct } from 'DashboardUser/store'
import { FilterPill } from '../Filters'

export default function BooleanColumnFilter({ fieldId }) {
  const act = useAct()
  const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => f.id === fieldId));
  const filterKey = 'field_' + fieldId;
  const filterValue = useSel(s => s.local.filters[filterKey] ?? null);

  function onPick(value) {
    console.log('Boolean column filtered:', value)
    act.local.setFilter(filterKey, value);
  }

  function clearFilter() {
    act.local.setFilter(filterKey, null);
  }

  return <div className='filter-field'>
    <label>{ dashboardField.name }</label>
    <div className='filter-button-group'>
      <button className={`filter-button ${filterValue === true ? 'selected' : ''}`} onClick={() => onPick(true)}>
        <span>Yes</span>
      </button>
      <button className={`filter-button ${filterValue === false ? 'selected' : ''}`} onClick={() => onPick(false)}>
        <span>No</span>
      </button>
      <button className='clear-filter' onClick={clearFilter} title="Clear filter">
        ×
      </button>
    </div>
  </div>
}

export function BooleanColumnPill({ value, onClear, fieldName }) {
  if (value === null || value === undefined || value === '') return null;

  return <FilterPill onClear={onClear}>
    {fieldName + ': ' + (value ? 'Yes' : 'No')}
  </FilterPill>
}
